export const safeStringTrim = (value: any): string => {
  if (value == null) return ''
  return String(value).trim()
}
